<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...$$restProps}>
	<mask
		id="mask0_1649_429"
		style="mask-type:alpha"
		maskUnits="userSpaceOnUse"
		x="0"
		y="0"
		width="16"
		height="16"
	>
		<rect width="16" height="16" fill="#D9D9D9" />
	</mask>
	<g mask="url(#mask0_1649_429)">
		<path
			d="M14.0501 9.3501L9.36677 14.0501C9.24454 14.1723 9.11121 14.2612 8.96676 14.3168C8.82232 14.3723 8.67232 14.4001 8.51677 14.4001C8.36121 14.4001 8.21121 14.3723 8.06676 14.3168C7.92232 14.2612 7.78899 14.1723 7.66676 14.0501L1.9451 8.32843C1.82621 8.20954 1.73899 8.07849 1.68343 7.93526C1.62788 7.79204 1.6001 7.64143 1.6001 7.48343V2.8001C1.6001 2.4701 1.7176 2.1876 1.9526 1.9526C2.1876 1.7176 2.4701 1.6001 2.8001 1.6001H7.48343C7.63799 1.6001 7.78776 1.62788 7.93276 1.68343C8.07765 1.73899 8.20971 1.82621 8.32893 1.9451L14.0501 7.66676C14.1723 7.78899 14.2612 7.91954 14.3168 8.05843C14.3723 8.19732 14.4001 8.34454 14.4001 8.5001C14.4001 8.65565 14.3722 8.80615 14.3164 8.9516C14.2607 9.09693 14.1719 9.22976 14.0501 9.3501ZM8.51677 13.2001L13.2001 8.51677L7.48343 2.8001H2.8001V7.48343L8.51677 13.2001ZM4.4001 5.4001C4.67788 5.4001 4.91399 5.30288 5.10843 5.10843C5.30288 4.91399 5.4001 4.67788 5.4001 4.4001C5.4001 4.12232 5.30288 3.88621 5.10843 3.69176C4.91399 3.49732 4.67788 3.4001 4.4001 3.4001C4.12232 3.4001 3.88621 3.49732 3.69176 3.69176C3.49732 3.88621 3.4001 4.12232 3.4001 4.4001C3.4001 4.67788 3.49732 4.91399 3.69176 5.10843C3.88621 5.30288 4.12232 5.4001 4.4001 5.4001Z"
			fill="currentColor"
		/>
	</g>
</svg>
